import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { ObjectListWidget } from '@plone/volto/components';

const messages = defineMessages({
  Source: {
    id: 'Source',
    defaultMessage: 'Source',
  },
  title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  icon: {
    id: 'Icon',
    defaultMessage: 'Icon',
  },
  description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  logo: {
    id: 'Logo image',
    defaultMessage: 'Logo image',
  },
  item: {
    id: 'Item',
    defaultMessage: 'Item',
  },
  items: {
    id: 'Items',
    defaultMessage: 'Items',
  },
  addLogo: {
    id: 'Add logo',
    defaultMessage: 'Add logo',
  },
  headline: {
    id: 'Headline',
    defaultMessage: 'Headline',
  },
  itemsToShow: {
    id: 'Items to show',
    defaultMessage: 'Items to show',
  },
  hideDescription: {
    id: 'Hide description',
    defaultMessage: 'Hide description',
  },
  settings: {
    id: 'Settings',
    defaultMessage: 'Settings',
  },
  openLinkInNewTab: {
    id: 'Open in a new tab',
    defaultMessage: 'Open in a new tab',
  },
});

const PreFooterWidget = (props) => {
  const { value } = props;
  const intl = useIntl();

  function onChange(id, value) {
    props.onChange(id, { items: value });
  }

  function schema(props) {
    return {
      title: intl.formatMessage(messages.item),
      addMessage: intl.formatMessage(messages.addLogo),
      fieldsets: [
        {
          id: 'default',
          title: 'Default',
          fields: ['title', 'logo', 'href', 'openLinkInNewTab'],
        },
      ],

      properties: {
        title: {
          title: intl.formatMessage(messages.title),
        },
        logo: {
          title: intl.formatMessage(messages.logo),
          widget: 'object_browser',
          selectedItemAttrs: ['Title', 'Description', 'image_field'],
          mode: 'image',
          allowExternals: true,
        },
        href: {
          title: intl.formatMessage(messages.Source),
          widget: 'object_browser',
          mode: 'link',
          selectedItemAttrs: ['Title', 'Description'],
          allowExternals: true,
        },
        openLinkInNewTab: {
          title: intl.formatMessage(messages.openLinkInNewTab),
          type: 'boolean',
        },
      },
      required: [],
    };
  }

  return (
    <ObjectListWidget
      {...props}
      value={value?.items}
      schema={schema}
      onChange={onChange}
    />
  );
};

export default PreFooterWidget;
